module.exports = "<app-header></app-header>\n<div class=\"main-container\">\n\n    \t<router-outlet></router-outlet>\n\n</div>\n<app-footer></app-footer>\n"